import React from "react"
import HostingIndexPage2 from "./HostingIndex2"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Container } from "reactstrap"

const HostingIndexMain = () => {
  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Work"} breadcrumbItem={"Hosting"} />
          <HostingIndexPage2 />
        </Container>
      </div>
    </div>
  )
}

export default HostingIndexMain
